import { render, staticRenderFns } from "./AdminCancelReasonForm.vue?vue&type=template&id=b04bb8d2&scoped=true&"
import script from "./AdminCancelReasonForm.vue?vue&type=script&lang=js&"
export * from "./AdminCancelReasonForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b04bb8d2",
  null
  
)

export default component.exports